import type { Matter } from "@/lib/types";
import { OverviewContent } from "./components/OverviewContent";

export default function MatterOverview({ matter }: { matter: Matter }) {
  return (
    <div className="bg-background min-h-full w-full px-6 pt-5 pb-5">
      <OverviewContent matter={matter} />
    </div>
  );
}
